export default __webpack_public_path__ + "static/media/arts_left.e6da2614.svg";